import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaDownload } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ebookPdf from '../assets/document/E-Book NR-1 - Erivan Figueredo.pdf';
import ebookImage from '../assets/images/ebookErivan.png';

const EbookHighlight = () => {
  const [formData, setFormData] = useState({ nome: '', email: '', _gotcha: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nome || !formData.email) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    if (formData._gotcha) {
      // Honeypot preenchido: comportamento típico de bot, ignora silenciosamente.
      setFormSubmitted(true);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch('https://formspree.io/f/mnnpejko', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setFormSubmitted(true);
      } else {
        setError('Erro ao enviar. Tente novamente mais tarde.');
      }
    } catch (err) {
      setError('Erro de conexão. Verifique sua internet.');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    // Baixa o PDF
    const link = document.createElement('a');
    link.href = ebookPdf;
    link.download = 'E-Book NR-1 - Erivan Figueredo.pdf';
    link.click();

    // Redireciona para a página de agradecimento
    navigate('/obrigado');
  };

  return (
    <section
      id="ebook"
      className="relative bg-gradient-to-b from-white via-[#fdf8f9] to-white text-darkblue1 py-24 px-6 font-cormorant overflow-hidden"
    >
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[600px] h-[600px] bg-darkredHighlight/10 blur-3xl rounded-full z-0" />

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20 px-4">
        {/* Imagem do E-book */}
        <motion.div
          className="flex-shrink-0 w-full max-w-sm mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <img
            src={ebookImage}
            alt="Capa do E-book"
            loading="lazy"
            className="w-full rounded-xl shadow-2xl border border-darkred1"
          />
        </motion.div>

        {/* Texto + Formulário ou botão de download */}
        <motion.div
          className="flex flex-col text-center lg:text-left items-center lg:items-start w-full"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {!formSubmitted ? (
            <>
              <h2 className="text-4xl md:text-5xl font-bold text-darkblue1 mb-6 leading-tight">
                EBOOK - PSICÓLOGA ERIVAN
              </h2>

              <p className="text-lg sm:text-xl text-darkblue2 max-w-xl mb-8 leading-relaxed">
                Preencha seu nome e e-mail para receber gratuitamente o eBook sobre <strong>Riscos Psicossociais e a nova NR-1</strong>.
              </p>

              <form onSubmit={handleSubmit} className="w-full max-w-md space-y-4">
                <input
                  type="text"
                  name="_gotcha"
                  value={formData._gotcha}
                  onChange={handleChange}
                  tabIndex="-1"
                  autoComplete="off"
                  aria-hidden="true"
                  className="absolute -left-[9999px] w-px h-px overflow-hidden"
                />

                <label htmlFor="ebook-nome" className="sr-only">Seu nome</label>
                <input
                  id="ebook-nome"
                  type="text"
                  name="nome"
                  placeholder="Seu nome"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-darkred1"
                />
                <label htmlFor="ebook-email" className="sr-only">Seu e-mail</label>
                <input
                  id="ebook-email"
                  type="email"
                  name="email"
                  placeholder="Seu e-mail"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-darkred1"
                />
                {error && <p className="text-red-600 text-sm">{error}</p>}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full inline-flex items-center justify-center gap-3 bg-darkred1 hover:bg-darkred2 text-white text-lg font-semibold px-6 py-3 rounded-md shadow-lg transition-all duration-300 transform hover:scale-105"
                >
                  {loading ? 'Enviando...' : (
                    <>
                      <FaDownload className="text-xl" />
                      Quero receber o E-book
                    </>
                  )}
                </button>
              </form>
            </>
          ) : (
            <button
              onClick={handleDownload}
              className="inline-flex items-center gap-3 bg-darkred1 hover:bg-darkred2 text-white text-lg font-semibold px-8 py-4 rounded-full shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <FaDownload className="text-xl" />
              Baixar E-Book Gratuitamente
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default EbookHighlight;
